/**
 * Application-wide constants
 */

/**
 * Supported languages
 */
export const LANGUAGES = {
  EN: 'en'
} as const;

export type Language = typeof LANGUAGES[keyof typeof LANGUAGES];

/**
 * Theme modes
 */
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  AUTO: 'auto',
} as const;

export type Theme = typeof THEMES[keyof typeof THEMES];

/**
 * User roles
 */
export const USER_ROLES = {
  ADMIN: 'admin',
  MERCHANT: 'merchant',
  SUPPORT: 'support',
  VIEWER: 'viewer',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

/**
 * Date format patterns
 */
export const DATE_FORMATS = {
  SHORT: 'MM/dd/yyyy',
  MEDIUM: 'MMM d, yyyy',
  LONG: 'MMMM d, yyyy',
  FULL: 'EEEE, MMMM d, yyyy',
  TIME: 'h:mm a',
  DATETIME: 'MMM d, yyyy h:mm a',
} as const;

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

/**
 * Validation limits
 */
export const LIMITS = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 128,
  EMAIL_MAX_LENGTH: 255,
  NAME_MAX_LENGTH: 100,
  DESCRIPTION_MAX_LENGTH: 500,
} as const;

/**
 * Timeout durations (in milliseconds)
 */
export const TIMEOUTS = {
  TOAST: 5000,
  API_REQUEST: 30000,
  DEBOUNCE: 300,
  THROTTLE: 1000,
} as const;

/**
 * Authentication constants
 */
export const AUTH = {
  // Token expiration time in seconds (30 days = 2,592,000 seconds)
  TOKEN_EXPIRATION: 30 * 24 * 60 * 60, // 30 days
  // Refresh token before it expires (5 minutes = 300 seconds)
  TOKEN_REFRESH_BUFFER: 5 * 60,
} as const;

/**
 * Feature flags
 */
export const FEATURES = {
  ENABLE_ANALYTICS: true,
  ENABLE_NOTIFICATIONS: true,
  ENABLE_EXPORT: true,
  ENABLE_DARK_MODE: true,
} as const;


